// extracted by mini-css-extract-plugin
module.exports = {"CardsContainer":"CardsContainer_CardsContainer__2MnSR"};